module.exports = __webpack_public_path__ + "img/1@2x.07f17b7b.png";